import { render, staticRenderFns } from "./BuildingTemplate.vue?vue&type=template&id=5fe81354&"
import script from "./BuildingTemplate.vue?vue&type=script&lang=js&"
export * from "./BuildingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BuildingTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fe81354')) {
      api.createRecord('5fe81354', component.options)
    } else {
      api.reload('5fe81354', component.options)
    }
    module.hot.accept("./BuildingTemplate.vue?vue&type=template&id=5fe81354&", function () {
      api.rerender('5fe81354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/BuildingTemplate.vue"
export default component.exports